<template>
  <b-field
    v-if="isVisible"
    label="Choose your co-branded page"
    class="page-selector"
  >
    <b-select
      v-model="selfSelectedPage"
      placeholder="Select a name"
      class="page-selector--select-wrapper"
    >
      <option
        v-for="option in pages"
        :value="option"
        :key="option.id"
      >
        {{ option.pageName }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import {
  mapActions,
  mapGetters,
} from 'vuex';
import * as ACTIONS from '@/store/actions';

export default {
  name: 'PageSelector',
  computed: {
    ...mapGetters(['pages', 'selectedPage']),
    isVisible() {
      return this.pages && this.pages.length > 1;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    selfSelectedPage: {
      get() {
        return this.selectedPage;
      },
      set(page) {
        this.setSelectedPage(page);
      },
    },
  },
  methods: {
    ...mapActions({
      setSelectedPage: ACTIONS.SET_SELECTED_PAGE,
    }),
  },
};
</script>

<style lang="stylus">
.marketing-materials .page-selector
  width 50%
  &.field
    margin-bottom 1.5rem
  & label
    color #969ea2
    font-size 16px
    font-weight 400
  &--select-wrapper
    span.select
      height 48px
      width 100%
      &:after
        border-color #525F66
      select
        height 48px
        width 100%
</style>
